"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const indices = {
  hide: -100,
  // equivalent to $z-index-negative in fe-core (https://github.com/spothero/fe-core/blob/main/utils/_defaults.scss)
  auto: 'auto',
  base: 0,
  // equivalent to $z-index-back in fe-core
  layer1: 100,
  // equivalent to $z-index-mid in fe-core
  layer2: 200,
  // equivalent to $z-index-fore in fe-core
  layer3: 300,
  // equivalent to $z-index-layer1 in fe-core
  layer4: 400,
  // equivalent to $z-index-layer2 in fe-core
  layer5: 500,
  // equivalent to $z-index-layer3 in fe-core
  layer6: 600,
  // equivalent to $z-index-layer4 in fe-core
  layer7: 700,
  // equivalent to $z-index-modal-shim in fe-core
  layer8: 800,
  // equivalent to $z-index-modal in fe-core
  layer9: 900,
  // equivalent to $z-index-notification in fe-core
  layer10: 1000 // equivalent to $z-index-top in fe-core
};
var _default = exports.default = indices;